import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Button, Form, Select, DatePicker, message, Row, Col } from 'antd';
import moment from 'moment';
import Header from '../../../components/Header';
import Sidebar from '../../../components/Sidebar';
import {
    ActionCreateBooking,
    ActionUpdateBooking,
    ActionGetBookingById
} from '../../../store/Actions/BookingAction';
import { GetPatientApi } from '../../../utils/api';
// Assuming RoomAction exists, if not, I'd need to assume a way to fetch rooms. 
// Using direct API for options in Select if Redux is not fully set up for options.

const { Option } = Select;

const AddBooking = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [form] = Form.useForm();
    const { id } = useLocation().state || {}; // Simple way to check if edit, or parse URL
    // Better to parse URL
    const bookingId = location.pathname.split('/').pop();
    const isEdit = location.pathname.includes('edit-booking');

    const [loading, setLoading] = useState(false);
    const [patientOptions, setPatientOptions] = useState([]);
    const [roomOptions, setRoomOptions] = useState([]);

    useEffect(() => {
        // Fetch Rooms - assuming a general fetch room action or API
        // For now, I will use a placeholder or assume rooms are fetched.
        // If I can't guarantee RoomAction, I would define a local fetch.
    }, []);

    useEffect(() => {
        if (isEdit && bookingId) {
            dispatch(ActionGetBookingById({ Query: `/${bookingId}` }));
        }
    }, [dispatch, isEdit, bookingId]);

    const { bookingData } = useSelector(state => state?.BookingManagement);

    useEffect(() => {
        if (isEdit && bookingData && Object.keys(bookingData).length > 0) {
            form.setFieldsValue({
                patientId: bookingData.patientId?.id || bookingData.patientId,
                roomId: bookingData.currentRoom?.roomId?.id,
                admissionDate: moment(bookingData.admissionDate),
                dischargeDate: moment(bookingData.dischargeDate),
                status: bookingData.status
            });
            // Also set initial options for patient if needed
            if (bookingData.patientId) {
                setPatientOptions([{ value: bookingData.patientId.id, label: bookingData.patientId.name }]);
            }
        }
    }, [bookingData, isEdit, form]);

    const onFinish = (values) => {
        setLoading(true);
        const payload = {
            ...values,
            admissionDate: values.admissionDate.format('YYYY-MM-DD'),
            dischargeDate: values.dischargeDate.format('YYYY-MM-DD'),
        };

        if (isEdit) {
            dispatch(ActionUpdateBooking({ Query: `/${bookingId}`, obj: payload }, (res) => {
                setLoading(false);
                if (res) {
                    message.success('Booking updated successfully');
                    window.location.href = '/room-booking';
                }
            }));
        } else {
            dispatch(ActionCreateBooking(payload, (res) => {
                setLoading(false);
                if (res) {
                    message.success('Booking created successfully');
                    window.location.href = '/room-booking';
                }
            }));
        }
    };

    // Mock search for patients - in real app, dispatch search action
    const handlePatientSearch = async (value) => {
        try {
            // Using the API helper directly or Action if available
            // Assuming GetPatientListApi exists as seen in api.js
            const res = await GetPatientApi({ Query: `?search=${value}` });
            if (res?.data?.data?.docs) {
                const options = res.data.data.docs.map(p => ({ value: p.id, label: p.name }));
                setPatientOptions(options);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/room-booking">Room Management</Link>
                                    </li>
                                    <li className="breadcrumb-item active">{isEdit ? 'Edit' : 'Add'} Booking</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <Form layout="vertical" form={form} onFinish={onFinish}>
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item name="patientId" label="Patient" rules={[{ required: true }]}>
                                                    <Select
                                                        showSearch
                                                        placeholder="Select Patient"
                                                        onSearch={handlePatientSearch}
                                                        filterOption={false}
                                                        options={patientOptions}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="roomId" label="Room" rules={[{ required: true }]}>
                                                    <Select placeholder="Select Room">
                                                        {/* Populate with roomOptions */}
                                                        <Option value="695393a0f6b0a2d6146c8f47">Royal one</Option>
                                                        <Option value="695393a0f6b0a2d6146c8f4a">Royal two</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="admissionDate" label="Admission Date" rules={[{ required: true }]}>
                                                    <DatePicker className="w-100" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="dischargeDate" label="Discharge Date" rules={[{ required: true }]}>
                                                    <DatePicker className="w-100" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item name="status" label="Status" initialValue="UPCOMING">
                                                    <Select>
                                                        <Option value="UPCOMING">Upcoming</Option>
                                                        <Option value="ONGOING">Ongoing</Option>
                                                        <Option value="COMPLETED">Completed</Option>
                                                        <Option value="CANCELLED">Cancelled</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <div className="text-end">
                                            <Button type="primary" htmlType="submit" loading={loading}>
                                                Submit
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddBooking;
